import React, { useState } from 'react';
import { FileUploader } from '../common/FileUploader';
export function FinancialsHistory() {
  const [selectedCategory, setSelectedCategory] = useState('Financial Statements');
  const categories = ['Financial Statements', 'Tax Returns', 'Business Plan', 'Cash Flow Projections', 'Bank Statements', 'Other Financial Documents'];
  return <div className="bg-white rounded-lg shadow" data-id="element-345">
      <div className="p-6" data-id="element-346">
        <h2 className="text-xl font-semibold mb-6" data-id="element-347">Financials & History</h2>
        <div className="grid grid-cols-1 gap-6 mb-6" data-id="element-348">
          <div className="bg-blue-50 p-6 rounded-lg" data-id="element-349">
            <h3 className="font-medium text-lg mb-4" data-id="element-350">Business History</h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-351">
              <div data-id="element-352">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-353">
                  Years in Business
                </label>
                <input type="number" className="w-full p-2 border rounded-md" placeholder="e.g. 5" data-id="element-354" />
              </div>
              <div data-id="element-355">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-356">
                  Annual Revenue (£)
                </label>
                <input type="text" className="w-full p-2 border rounded-md" placeholder="e.g. 1,000,000" data-id="element-357" />
              </div>
              <div data-id="element-358">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-359">
                  Number of Employees
                </label>
                <input type="number" className="w-full p-2 border rounded-md" placeholder="e.g. 25" data-id="element-360" />
              </div>
              <div data-id="element-361">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-362">
                  Business Growth Rate (%)
                </label>
                <input type="number" className="w-full p-2 border rounded-md" placeholder="e.g. 15" data-id="element-363" />
              </div>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-364">
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-365">
            <h3 className="font-medium text-lg mb-4" data-id="element-366">Financial Documents</h3>
            <div className="mb-4" data-id="element-367">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-368">
                Document Category
              </label>
              <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} className="w-full p-2 border rounded-md" data-id="element-369">
                {categories.map(category => <option key={category} value={category} data-id="element-370">
                    {category}
                  </option>)}
              </select>
            </div>
            <FileUploader data-id="element-371" />
            <div className="mt-6 text-sm text-gray-500" data-id="element-372">
              <p data-id="element-373">Acceptable document formats: PDF, DOC, DOCX, XLS, XLSX</p>
              <p data-id="element-374">Maximum file size: 10MB</p>
            </div>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-375">
            <h3 className="font-medium text-lg mb-4" data-id="element-376">Document Requirements</h3>
            <div className="space-y-4" data-id="element-377">
              <div data-id="element-378">
                <h4 className="font-medium" data-id="element-379">Financial Statements</h4>
                <p className="text-sm text-gray-600" data-id="element-380">
                  Balance sheets, income statements, and cash flow statements
                  for the past 3 years.
                </p>
              </div>
              <div data-id="element-381">
                <h4 className="font-medium" data-id="element-382">Tax Returns</h4>
                <p className="text-sm text-gray-600" data-id="element-383">
                  Business tax returns for the past 3 years.
                </p>
              </div>
              <div data-id="element-384">
                <h4 className="font-medium" data-id="element-385">Business Plan</h4>
                <p className="text-sm text-gray-600" data-id="element-386">
                  Current business plan including growth projections and
                  strategy.
                </p>
              </div>
              <div data-id="element-387">
                <h4 className="font-medium" data-id="element-388">Cash Flow Projections</h4>
                <p className="text-sm text-gray-600" data-id="element-389">
                  Projected cash flow for the next 12-24 months.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}